import http from "../../http-common";

class NotifySchoolService {
    searchNotifySchool(pageNumber, maxPageItem, active, dateList, title, content, scope) {
        return http.get(`/notify-school/search?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&active=${active}&dateList=${dateList}&title=${title}&content=${content}&scope=${scope}`);
    }

    checkNewConfigCount(){
        return http.get(`/notify-school/newsConfig/count`);
    }
    findByNotifySchool(id){
        return http.get(`/notify-school/detail/${id}`);
    }

    getActiveNotifySchool(data){
        return http.put("/notify-school/active",data);
    }

    getApprovedNotifySchool(data){
        return http.put("/notify-school/approved",data);
    }

    createNotifySchool(data){
        return http.post("/notify-school/create",data);
    }

    updateNotifySchool(data){
        return http.put("/notify-school/update",data);
    }
    
    deleteNotifySchool(id){
        return http.delete(`/notify-school/delete/${id}`);
    }

    setPinPost({id, pin, endPinDate}) {
        return http.post(`/notify-school/pin`, {id, pin, endPinDate})
    }

}

export default new NotifySchoolService();